import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { updateWithdrawStatusSuccess, updateWithdrawStatusFailure } from "../../Action";
import { WITHDRAW_ACTION } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";
import {ADD_BALANCE_PARAMS} from "../../../Utils/Constants"
function* updateWithdrawStatusRequest(action) {
  try {
    const { type, id ,paramsType } = action?.payload?.payload || {};
    const { data } = yield notifyPromise(
      API.get(`/emailwithdraw-accept-reject?_id=${id}&type=${type}&paramsType=${ADD_BALANCE_PARAMS}`),
      type === 'accept' ? 'Accepting...' : 'Rejecting...'
    );

    if (data?.meta?.code === 200) {
      yield put(updateWithdrawStatusSuccess(data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(updateWithdrawStatusFailure());
    }
  } catch (error) {
    yield put(updateWithdrawStatusFailure());
  }
}

export function* watchUpdateWithdrawStatusAPI() {
  yield takeEvery(WITHDRAW_ACTION, updateWithdrawStatusRequest);
}

export default function* rootSaga() {
  yield all([watchUpdateWithdrawStatusAPI()]);
}
